import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import { getServerData } from '~/core/get-server-data'

import App from './components/Card'
import { getStore } from './rtk/store'

const serverData = getServerData()
const store = getStore(serverData)

const appElement = document.querySelector('#app')
if (appElement) {
    hydrateRoot(
        appElement,
        <Provider store={store}>
            <App />
        </Provider>,
    )
}
